import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

type ProfileHierarchyContextValue = {
  isEditingHierarchy: boolean;
  setEditingHierarchy: (editing: boolean) => void;
};

const ProfileHierarchyContext = createContext<ProfileHierarchyContextValue | undefined>(
  undefined,
);

type Props = {
  children: React.ReactNode;
};

export const ProfileHierarchyProvider: React.FC<Props> = ({ children }) => {
  const [isEditingHierarchy, setIsEditingHierarchy] = useState(false);

  const setEditingHierarchy = useCallback((editing: boolean) => {
    setIsEditingHierarchy(editing);
  }, []);

  const contextValue = useMemo(
    (): ProfileHierarchyContextValue => ({
      isEditingHierarchy,
      setEditingHierarchy,
    }),
    [isEditingHierarchy, setEditingHierarchy],
  );

  return (
    <ProfileHierarchyContext.Provider value={contextValue}>
      {children}
    </ProfileHierarchyContext.Provider>
  );
};

export const useProfileHierarchy = (): ProfileHierarchyContextValue => {
  const context = useContext(ProfileHierarchyContext);
  if (!context) {
    throw new Error("useProfileHierarchy must be used within a ProfileHierarchyProvider");
  }
  return context;
};
